import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])])]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'DEVICE_RECHARGE_ALL',
        delete: 'DEVICE_RECHARGE_DELETE'
      },
      permission: {
        query: '',
        add: '',
        edit: '',
        detail: '',
        remove: ''
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      return [{
        prop: 'id',
        label: 'id',
        minWidth: '80px'
      }, {
        prop: 'market_id',
        label: 'market_id',
        minWidth: '80px'
      }, {
        prop: 'device_number',
        label: 'device_number',
        minWidth: '80px'
      }, {
        prop: 'app_id',
        label: 'app_id',
        width: '330px'
      }, {
        prop: 'key',
        label: 'key',
        width: '330px'
      }, {
        prop: 'order_no',
        label: 'order_no',
        width: '330px'
      }, {
        prop: 'sign',
        label: 'sign',
        width: '330px'
      }, {
        prop: 'last_extend_service_long',
        label: 'last_extend_service_long',
        width: '330px'
      }, {
        prop: 'start_servcie_time',
        label: 'start_servcie_time',
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.start_servcie_time, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'end_service_time',
        label: 'end_service_time',
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.end_service_time, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'c_time',
        label: 'c_time',
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.c_time, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'u_time',
        label: 'u_time',
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.u_time, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'pay_time',
        label: 'pay_time',
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.pay_time, 'YYYY/M/D HH:mm:ss');
        }
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this2 = this;

      return function (_ref) {
        var row = _ref.row;
        return _toConsumableArray(_this2.p('edit', [{
          icon: 'el-icon-edit-outline',
          label: 'edit',
          action: function action() {
            return _this2.edit(row.id);
          }
        }], []));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this3 = this;

      var h = this.$createElement;
      return [{
        prop: 'device_uid',
        label: 'device_uid',
        default: this.device_uid,
        render: function render() {
          return h("el-input", {
            "style": "width:300px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this3.search.form.model.device_uid,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "device_uid", $$v);
              }
            }
          });
        } //  render: () => <d2-dict-select name="search_market_id" vModel={ this.search.form.model.market_id } style="width:100px;" custom clearable/>

      }, {
        prop: 'start_time',
        label: 'start_time',
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "start_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.start_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: 'end_time',
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "end_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.end_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }];
    },
    // [本页面特有] 父级字典项目的 id 强制转为数字
    device_uid: function device_uid() {
      return this.$route.query.device_uid;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['closeBy'])), {}, {
    /**
     * @description 加载需要的字典数据
     */
    loadDict: function loadDict() {
      //
      this.loadDictOne({
        name: 'search_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      }); //

      this.loadDictOne({
        name: 'market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
    }
  })
};